import {
  OnInit,
  Component,
  EventEmitter,
  Input,
  Output,
  Renderer2,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { Development, imageLoad } from "@models/development.model";
import { DropDown, Project } from "@models/project.model";
import { CommonServiceService } from "@services/common-service.service";
import { ImageProcessingService } from "@services/image-processing.service";
import { environment } from "src/environments/environment";
interface projectDisplay {
  projectType: string;
  projects: Project[];
  NoOfProject: number;
}
@Component({
  selector: "app-development-summary",
  templateUrl: "./development-summary.component.html",
  styleUrls: ["./development-summary.component.scss"],
})

export class DevelopmentSummaryComponent implements AfterViewInit, OnChanges {
  projectList: projectDisplay[] = [];

  sortingProjects = ["Completed", "Active", "On Hold", "Planned"];

  @Input()
  set selectedProjectStatus(selectedProjectStatus: DropDown[]) {
    this._projectstatus = selectedProjectStatus;
  }

  get selectedProjectStatus(): DropDown[] {
    return this._projectstatus;
  }

  @Input()
  set development(development: Development) {
    this._development = development;
  }

  get development(): Development {
    return this._development;
  }

  _projectstatus!: DropDown[];

  @Output() closeModal = new EventEmitter<boolean>();

  _development!: Development;
  ProjectsInDevelopment: Project[] = [];
  totalProjects = 0;
  twentyYearCapitalNeeds = 0;
  constructor(
    private imageProcessingService: ImageProcessingService,
    private commonServiceService: CommonServiceService,
    private renderer: Renderer2,
  ) {}
  ngOnChanges(): void {
    this.generateProjects();
  }
  async ngAfterViewInit(): Promise<void> {
    for (const project of this.ProjectsInDevelopment) {
      try {
        const loadedImages: imageLoad[] = [];
        await this.projectPhotos(project.projectPicture ?? "").then((imageLoad: imageLoad[]) => {
          if (imageLoad.length === 0) {
            const img = this.renderer.createElement("img");
            this.renderer.listen(img, "load", () => {
              loadedImages.push({
                imgPath: environment.defaultPhotoPhoto,
                height: img.height,
                width: img.width,
              });
              project.projectImage = loadedImages;
            });
            this.renderer.setAttribute(img, "src", environment.defaultPhotoPhoto);
          } else {
            loadedImages.push(...imageLoad);
            project.projectImage = loadedImages;
          }
        });
      } catch (error) {
        console.error("Error updating project image:", error, project.projectPicture);
      }
    }
  }
  generateProjects() {
    this.ProjectsInDevelopment = [];
    this.projectList = [];
    this.ProjectsInDevelopment = this._development.areasOfWork.map((a) => a.projects).flat();

    for (const status of this._projectstatus.filter((d) => d.checked)) {
      const filteredProjects = this.ProjectsInDevelopment.filter(
        (x) => x.projectStatus == status.label,
      );

      if (filteredProjects.length > 0) {
        this.projectList.push({
          projectType: status.label,
          projects: filteredProjects.length > 3 ? filteredProjects.slice(0, 3) : filteredProjects,
          NoOfProject: filteredProjects.length,
        });
      }
    }

    this.projectList.sort(
      (a, b) =>
        this.sortingProjects.indexOf(a.projectType) - this.sortingProjects.indexOf(b.projectType),
    );

    this.twentyYearCapitalNeeds = this._development.areasOfWork.reduce(
      (acc, curr) => acc + curr.twentyYearCapitalNeeds,
      0,
    );
  }

  triggerClose(): void {
    this.closeModal.emit(true);
  }

  async projectPhotos(photoName: string): Promise<imageLoad[]> {
    const imageLoad: imageLoad[] = [];
    const containerUrl = environment.projectPhotos;
    return new Promise<imageLoad[]>((resolve, reject) => {
      this.imageProcessingService.getProjectBlobPhotos(containerUrl, photoName).subscribe(
        (response) => {
          const loadPromises: Promise<void>[] = [];
          response.forEach((x) => {
            const img = this.renderer.createElement("img");
            const loadPromise = new Promise<void>((innerResolve) => {
              this.renderer.listen(img, "load", () => {
                imageLoad.push({
                  imgPath: containerUrl.concat(x),
                  height: img.height,
                  width: img.width,
                });
                innerResolve();
              });
            });

            loadPromises.push(loadPromise);
            this.renderer.setAttribute(img, "src", containerUrl.concat(x));
          });

          Promise.all(loadPromises).then(() => {
            resolve(imageLoad);
          });
        },
        (error) => {
          console.error(error);
          reject(error);
        },
      );
    });
  }
}
